import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Báo cáo BOD (Ezy). Mã nghiệp vụ, tên bảng, tên riêng và dữ liệu không dịch.
addMessages('vi', {
  'bod.dk.w1': 'Chờ BOD duyệt',
  'bod.dk.w1s': '1 vụ · [BOD-DIR] PHILIP',
  'bod.dk.w1i': 'KPE-2610-001 · Sai chứng từ → phí amend/manifest',
  'bod.dk.w2': 'Kiểm soát',
  'bod.dk.w2s': 'tự duyệt / kiêm nhiệm',
  'bod.dk.w2i': 'Báo cáo tự duyệt & kiêm nhiệm',
  'bod.dk.w2is': 'ở bàn BOD · Tổng quan',
  'bod.dk.w2l': 'Mở bàn BOD ›',
  'bod.dk.w3s': 'điểm theo vị trí · chốt kỳ',
  'bod.dk.w3i': 'Kỳ Oct/2026 đang mở',
  'bod.dk.w3is': 'chưa chốt',
  'bod.dk.w3l': 'Mở KPI ›',
  'bod.dk.n0': 'Ghi chú dữ liệu',
  'bod.dk.n0s': 'đọc trước khi so kỳ',
  'bod.dk.n1': 'Tháng 10 tính đến 22/Oct/2026',
  'bod.dk.n1s': 'job có JobDate tương lai vẫn được đếm',
  'bod.dk.n2': 'Khách / hãng là số khác nhau',
  'bod.dk.n2s': 'theo tháng · quý / năm hiện trung bình tháng',
  'bod.dk.n3': 'Top khách, tuyến: 90 ngày',
  'bod.dk.n3s': 'không đổi theo kỳ đang chọn',
  'bod.dk.n4': 'Dịch vụ con: số dòng',
  'bod.dk.n4s': 'một job có thể nhiều dòng dịch vụ',
  'bod.later': 'Chưa mở ở bản này',
  'bod.title': 'Báo cáo BOD', 'bod.backLabel': 'Về Tổng quan',
  'bod.mode.m': 'Tháng', 'bod.mode.q': 'Quý', 'bod.mode.y': 'Năm',
  'bod.modeLabel': 'Loại kỳ', 'bod.prev': 'Kỳ trước', 'bod.next': 'Kỳ sau', 'bod.density': 'Mật độ hiển thị',
  'bod.dense.std': 'Chuẩn', 'bod.dense.cmp': 'Gọn',
  'bod.notif': 'Thông báo', 'bod.openRight': 'Mở cột phải', 'bod.export': 'Xuất báo cáo tháng',
  'bod.reports': 'Báo cáo', 'bod.tab.ops': 'Hoạt động KD', 'bod.tab.svc': 'Hiệu suất dịch vụ', 'bod.tab.evt': 'Sai sót & khen thưởng',
  'bod.vsPrev': ' so kỳ trước', 'bod.prevNone': 'kỳ trước: —', 'bod.prevNone2': 'kỳ trước —', 'bod.prevVal': '{d} · trước {v}',
  'bod.spark': '{k} 12 tháng {a}–{b}',
  'bod.avgSuffix': ' · TB/tháng',
  'bod.sec.metrics': 'Chỉ số',
  'bod.t.jobs': 'Job trong kỳ', 'bod.t.ob': 'OB · xuất', 'bod.t.ls': 'LS · logistics', 'bod.t.tr': 'TR · vận tải', 'bod.t.rf': 'Hàng lạnh RF',
  'bod.t.rfSub': '{p} tổng job', 'bod.t.cus': 'Khách có job', 'bod.t.cusSub': 'khách khác nhau', 'bod.t.car': 'Hãng tàu', 'bod.t.carSub': 'hãng khác nhau', 'bod.t.trf': 'Chuyến TRF',
  'bod.chart': 'Job theo tháng', 'bod.chartSub': 'theo JobDate', 'bod.peak': 'đỉnh 560 job',
  'bod.chartAria': 'Job theo tháng, chia OB / LS / TR / IB: {v}',
  'bod.open': 'Job chưa hoàn tất', 'bod.openSub': '120 ngày gần nhất',
  'bod.openAria': 'Job chưa hoàn tất theo nhóm: {v}', 'bod.openAria2': 'Job chưa hoàn tất theo ShipmentStatus',
  'bod.notFinish': 'chưa Finish',
  'bod.etd14': 'ETD trong 14 ngày tới', 'bod.cus90': 'Khách hoạt động 90 ngày',
  'bod.sub': 'Dịch vụ con', 'bod.subSub': 'số dòng theo JobDate', 'bod.thisP': 'Kỳ này', 'bod.prevP': 'Kỳ trước',
  'bod.subAria': 'Dịch vụ con: {v}', 'bod.opening': '{src} · đang mở {n}',
  'bod.s.trf': 'TRF · Vận tải (chuyến)', 'bod.s.doc': 'DOC · Chứng từ (C/O, kiểm dịch, hun trùng)', 'bod.s.ccf': 'CCF · Thông quan', 'bod.s.scy': 'SCY · Bãi / CY', 'bod.s.ddl': 'DDL · Giao nhận chứng từ', 'bod.s.svcj': 'Job có dịch vụ phụ',
  'bod.fin': 'Chứng từ tài chính', 'bod.finSub': 'số chứng từ trong kỳ · không kèm số tiền',
  'bod.f.dn': 'Debit note bán ra', 'bod.f.jdn': 'Job đã báo nợ', 'bod.f.pt': 'Phiếu thu', 'bod.f.pi': 'HĐ mua vào', 'bod.f.pc': 'Phiếu chi đối tác', 'bod.f.odn': 'Đề nghị chi Ops',
  'bod.dock': 'Cột phải', 'bod.dockClose': 'Đóng cột phải',
  'bod.dock.wait': 'Chờ duyệt', 'bod.dock.note': 'Ghi chú dữ liệu',
  'bod.ph.back': 'Về mục Thêm', 'bod.ph.dark': 'Chuyển giao diện tối', 'bod.ph.jobs': 'Job trong kỳ', 'bod.ph.cus': 'Khách có job', 'bod.ph.cusSub': 'khách khác nhau', 'bod.ph.avgMonth': 'TB / tháng', 'bod.ph.trf': 'Chuyến TRF', 'bod.ph.svc': 'Dòng dịch vụ con',
  'bod.ph.chart': 'Job theo tháng', 'bod.ph.12m': '12 tháng', 'bod.ph.wait': 'Chờ BOD duyệt', 'bod.ph.evs': 'Sai sót & khen thưởng', 'bod.ph.waitN': '{n} chờ BOD duyệt',
  'bod.ph.e1': 'Sai sót L2 · ThuyNTT · SE261040115', 'bod.ph.e2': 'Sai sót L3 · ANHLT, KietLT · SE261040322', 'bod.ph.e3': 'Khen thưởng · ThuongLVH · SE261040201', 'bod.ph.e4': 'Sai sót L2 · TUANNT, HOATTN · SE261040455',
  'bod.ph.sConfirmed': 'Chờ BOD duyệt', 'bod.ph.sPending': 'Chờ TP xác nhận', 'bod.ph.sExplain': 'Chờ giải trình',
  'bod.ph.open': 'Job chưa hoàn tất', 'bod.ph.open120': '· 120 ngày', 'bod.ph.kpi': 'KPI kỳ Oct/2026', 'bod.ph.kpiSub': 'Đang mở · chốt kỳ ở bản desktop',
});
addMessages('en', {
  'bod.dk.w1': 'Awaiting BOD approval',
  'bod.dk.w1s': '1 case · [BOD-DIR] PHILIP',
  'bod.dk.w1i': 'KPE-2610-001 · Document error → amend/manifest fee',
  'bod.dk.w2': 'Controls',
  'bod.dk.w2s': 'self-approved / concurrent roles',
  'bod.dk.w2i': 'Self-approval & concurrent-role report',
  'bod.dk.w2is': 'on BOD desk · Overview',
  'bod.dk.w2l': 'Open BOD desk ›',
  'bod.dk.w3s': 'score by position · period close',
  'bod.dk.w3i': 'Period Oct/2026 is open',
  'bod.dk.w3is': 'not closed',
  'bod.dk.w3l': 'Open KPI ›',
  'bod.dk.n0': 'Data notes',
  'bod.dk.n0s': 'read before comparing periods',
  'bod.dk.n1': 'October up to 22/Oct/2026',
  'bod.dk.n1s': 'jobs with a future JobDate are still counted',
  'bod.dk.n2': 'Customers / carriers are distinct counts',
  'bod.dk.n2s': 'monthly · quarter / year show monthly average',
  'bod.dk.n3': 'Top customers, lanes: 90 days',
  'bod.dk.n3s': 'does not change with the selected period',
  'bod.dk.n4': 'Sub-services: row count',
  'bod.dk.n4s': 'one job can have several service rows',
  'bod.later': 'Not available in this version',
  'bod.title': 'BOD report', 'bod.backLabel': 'Back to Overview',
  'bod.mode.m': 'Month', 'bod.mode.q': 'Quarter', 'bod.mode.y': 'Year',
  'bod.modeLabel': 'Period type', 'bod.prev': 'Previous period', 'bod.next': 'Next period', 'bod.density': 'Display density',
  'bod.dense.std': 'Standard', 'bod.dense.cmp': 'Compact',
  'bod.notif': 'Notifications', 'bod.openRight': 'Open right panel', 'bod.export': 'Export monthly report',
  'bod.reports': 'Reports', 'bod.tab.ops': 'Business activity', 'bod.tab.svc': 'Service performance', 'bod.tab.evt': 'Errors & rewards',
  'bod.vsPrev': ' vs previous period', 'bod.prevNone': 'previous: —', 'bod.prevNone2': 'previous —', 'bod.prevVal': '{d} · prev {v}',
  'bod.spark': '{k} 12 months {a}–{b}',
  'bod.avgSuffix': ' · avg/month',
  'bod.sec.metrics': 'Metrics',
  'bod.t.jobs': 'Jobs in period', 'bod.t.ob': 'OB · export', 'bod.t.ls': 'LS · logistics', 'bod.t.tr': 'TR · transport', 'bod.t.rf': 'Reefer RF',
  'bod.t.rfSub': '{p} of total jobs', 'bod.t.cus': 'Customers with jobs', 'bod.t.cusSub': 'distinct customers', 'bod.t.car': 'Carriers', 'bod.t.carSub': 'distinct carriers', 'bod.t.trf': 'TRF trips',
  'bod.chart': 'Jobs by month', 'bod.chartSub': 'by JobDate', 'bod.peak': 'peak 560 jobs',
  'bod.chartAria': 'Jobs by month, split OB / LS / TR / IB: {v}',
  'bod.open': 'Unfinished jobs', 'bod.openSub': 'last 120 days',
  'bod.openAria': 'Unfinished jobs by group: {v}', 'bod.openAria2': 'Unfinished jobs by ShipmentStatus',
  'bod.notFinish': 'not Finish yet',
  'bod.etd14': 'ETD in next 14 days', 'bod.cus90': 'Customers active in 90 days',
  'bod.sub': 'Sub-services', 'bod.subSub': 'rows by JobDate', 'bod.thisP': 'This period', 'bod.prevP': 'Previous period',
  'bod.subAria': 'Sub-services: {v}', 'bod.opening': '{src} · {n} open',
  'bod.s.trf': 'TRF · Transport (trips)', 'bod.s.doc': 'DOC · Documents (C/O, quarantine, fumigation)', 'bod.s.ccf': 'CCF · Customs clearance', 'bod.s.scy': 'SCY · Yard / CY', 'bod.s.ddl': 'DDL · Document delivery', 'bod.s.svcj': 'Jobs with extra services',
  'bod.fin': 'Financial documents', 'bod.finSub': 'documents in period · no amounts',
  'bod.f.dn': 'Debit notes issued', 'bod.f.jdn': 'Jobs billed', 'bod.f.pt': 'Receipts', 'bod.f.pi': 'Purchase invoices', 'bod.f.pc': 'Partner payment vouchers', 'bod.f.odn': 'Ops payment requests',
  'bod.dock': 'Right panel', 'bod.dockClose': 'Close right panel',
  'bod.dock.wait': 'Pending approval', 'bod.dock.note': 'Data notes',
  'bod.ph.back': 'Back to More', 'bod.ph.dark': 'Switch to dark theme', 'bod.ph.jobs': 'Jobs in period', 'bod.ph.cus': 'Customers with jobs', 'bod.ph.cusSub': 'distinct customers', 'bod.ph.avgMonth': 'avg / month', 'bod.ph.trf': 'TRF trips', 'bod.ph.svc': 'Sub-service lines',
  'bod.ph.chart': 'Jobs by month', 'bod.ph.12m': '12 months', 'bod.ph.wait': 'Awaiting BOD approval', 'bod.ph.evs': 'Errors & commendations', 'bod.ph.waitN': '{n} awaiting BOD approval',
  'bod.ph.e1': 'Error L2 · ThuyNTT · SE261040115', 'bod.ph.e2': 'Error L3 · ANHLT, KietLT · SE261040322', 'bod.ph.e3': 'Commendation · ThuongLVH · SE261040201', 'bod.ph.e4': 'Error L2 · TUANNT, HOATTN · SE261040455',
  'bod.ph.sConfirmed': 'Awaiting BOD', 'bod.ph.sPending': 'Awaiting head', 'bod.ph.sExplain': 'Awaiting explanation',
  'bod.ph.open': 'Unfinished jobs', 'bod.ph.open120': '· 120 days', 'bod.ph.kpi': 'KPI period Oct/2026', 'bod.ph.kpiSub': 'Open · close the period on desktop',
});
